import React from 'react';
import { StandardRates } from '../components';

export default () => {
    return (
        <StandardRates.Home />
    )
}